<template>
    <div v-if="showModal">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color allotment-select-header">
                                <div>
                                    <span class="allotment-select-kicker">Escopo de trabalho</span>
                                    <h5 class="modal-title mb-0" id="modalId">{{ t('APP.MODAL.ALLOTMENT') }}</h5>
                                </div>
                            </div>
                            <div class="modal-body modal-open pb-0 allotment-select-body">
                                <div class="row gutters">
                                    <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                                        <div class="form-group mb-1">
                                            <label for="allotment" class="allotment-search-label">Buscar loteamento</label>
                                            <input type="text" name="allotment" v-model="allotmentModal" id="allotment"
                                                   class="form-control allotment-search-input" @keyup="selectModal"
                                                   placeholder="Digite o nome do loteamento para buscar">
                                            <div class="allotment-list modal-row2">
                                                <div v-for="allotment in allotmentsModal" :key="allotment.id" class="allotment-list-item">
                                                    <button class="btn allotment-option-button"
                                                            @click="allotmentSelected(allotment.id)">
                                                        <span class="allotment-option-avatar">{{ allotment.text?.charAt(0) }}</span>
                                                        <span class="allotment-option-name">{{ allotment.text }}</span>
                                                        <span class="allotment-option-icon icon-keyboard_arrow_right"></span>
                                                    </button>
                                                </div>
                                                <div class="allotment-empty-state" v-if="!allotmentsModal || !allotmentsModal.length">
                                                    Nenhum loteamento encontrado
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-secondary" @click="backButton">{{ t('ACTIONS.BACK') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from "vue-i18n";

export default {
    nome: 'modalSelectAllotment',
    props: {
        isReserve: {
            default: false,
            type: Boolean
        },
        isProposal: {
            default: false,
            type: Boolean
        },
        isContract: {
            default: false,
            type: Boolean
        },
        isUser: {
            default: false,
            type: Boolean
        },
        scopeAllotment: {
            default: false,
            type: Boolean
        },
        showModal: {
            default: false,
            type: Boolean
        }
    },
    setup() {
        const {t} = useI18n();
        return {t}
    },
    emits:['showModal', 'allotmentSelected'],
    computed: {
        ...mapState({
            allotments: 'allotments',
        }),
    },

    data() {
        return {
            aux: [],
            backup: [],
            allotmentId: null,
            allotmentsModal: [],
            allotmentModal: null,
        }
    },

    mounted() {
        this.allotmentsModal = this.allotments;
    },

    created() {
        this.backup = this.allotments;
    },

    methods: {
        backButton(){
            document.getElementById('closeX')?.click();
            this.$router.go(-1)
        },
        selectModal() {
            this.aux = [];
            this.allotmentsModal = this.backup;
            this.allotmentsModal.forEach(allotment => {

                const text = allotment.text.toUpperCase();
                const textModal = this.allotmentModal.toUpperCase();

                if (text.includes(textModal)) {
                    this.aux.push(allotment);
                }
            })
            this.allotmentsModal = this.aux;
        },

        allotmentSelected(allotment_id) {
            this.$emit('showModal', false);
            this.allotmentId = allotment_id;
            if (this.isReserve) {
                localStorage.removeItem('reserveAllotmentId');
                localStorage.setItem('reserveAllotmentId', allotment_id);
            } else if (this.isProposal) {
                localStorage.removeItem('proposalAllotmentId');
                localStorage.setItem('proposalAllotmentId', allotment_id);
            } else if (this.isContract) {
                localStorage.removeItem('contractAllotmentId');
                localStorage.setItem('contractAllotmentId', allotment_id);
            }else if (this.isUser) {
                localStorage.removeItem('userAllotmentId');
                localStorage.setItem('userAllotmentId', allotment_id);
            }else if (this.scopeAllotment) {
                sessionStorage.removeItem('allotmentIdScope');
                sessionStorage.setItem('allotmentIdScope', allotment_id);
            }else {
                sessionStorage.removeItem('allotmentId');
                sessionStorage.setItem('allotmentId', allotment_id);
            }
            this.$emit('allotmentSelected');
        },
    }
}
</script>

<style scoped>
.allotment-select-header {
    align-items: flex-start;
    padding: 1.35rem 1.5rem;
}

.allotment-select-kicker {
    display: block;
    margin-bottom: 0.25rem;
    color: rgba(255, 255, 255, 0.72);
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.allotment-select-body {
    --allotment-panel: #ffffff;
    --allotment-panel-soft: #f8fafc;
    --allotment-border: #e2e8f0;
    --allotment-text: #0f172a;
    --allotment-muted: #64748b;
    --allotment-primary: #0e5e4e;
    padding: 1.5rem 1.5rem 0 !important;
    overflow-x: hidden;
}

.allotment-search-label {
    margin-bottom: 0.45rem;
    color: var(--allotment-muted);
    font-size: 0.78rem;
    font-weight: 800;
}

.allotment-search-input {
    height: 48px;
    margin-bottom: 1rem;
    border: 1px solid var(--allotment-border);
    background: var(--allotment-panel-soft);
    color: var(--allotment-text);
    box-shadow: none;
}

.allotment-search-input:focus {
    border-color: var(--allotment-primary);
    box-shadow: 0 0 0 0.2rem rgba(14, 94, 78, 0.12);
}

.allotment-list {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0.65rem;
    max-height: 48vh;
    padding-right: 0.25rem;
    max-width: 100%;
    overflow-x: hidden;
}

.allotment-list-item {
    min-width: 0;
    max-width: 100%;
}

.allotment-option-button {
    width: 100%;
    max-width: 100%;
    min-height: 58px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.85rem;
    padding: 0.75rem 0.9rem;
    border: 1px solid var(--allotment-border);
    background: var(--allotment-panel);
    color: var(--allotment-text);
    text-align: left;
    font-weight: 700;
    transition: transform .16s ease, border-color .16s ease, background-color .16s ease, box-shadow .16s ease;
}

.allotment-option-button:hover,
.allotment-option-button:focus {
    transform: translateY(-1px);
    border-color: rgba(14, 94, 78, 0.35);
    background: var(--allotment-panel-soft);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    color: var(--allotment-text);
}

.allotment-option-avatar {
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    background: rgba(14, 94, 78, 0.12);
    color: var(--allotment-primary);
    font-weight: 900;
    text-transform: uppercase;
}

.allotment-option-name {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
    white-space: normal;
    word-break: break-word;
}

.allotment-option-icon {
    flex: 0 0 auto;
    color: var(--allotment-muted);
    font-size: 1.35rem;
}

.allotment-empty-state {
    padding: 1.35rem;
    border: 1px dashed var(--allotment-border);
    color: var(--allotment-muted);
    text-align: center;
    font-weight: 700;
}

@media (max-width: 575.98px) {
    .allotment-select-body {
        padding: 1rem 1rem 0 !important;
    }

    .allotment-option-button {
        align-items: flex-start;
        gap: 0.65rem;
        padding: 0.75rem;
    }

    .allotment-option-name {
        flex-basis: calc(100% - 48px);
    }

    .allotment-option-icon {
        margin-left: auto;
    }
}
</style>
